import React from "react";
import { create } from "zustand";

export const useAlert = create((set) => ({}));

export const useModal = create((set) => ({
  open: false,
  children: undefined,
  handleOpen: (children) => set({ open: true, children: children }),
  handleClose: () => set({ open: false, children: null }),
}));
